var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.62845V29.16C31.9811 29.2017 31.9658 29.2453 31.9542 29.2902C31.6814 30.9396 30.5919 31.9987 29.1074 31.9987C20.371 31.9987 11.634 31.9987 2.89643 31.9987C2.45016 31.996 2.00963 31.8843 1.60468 31.671C0.484653 31.0676 0 29.9847 0 28.5958C0 21.0724 0 13.549 0 6.0256V5.72177C0.066978 5.80013 0.115533 5.89641 0.141194 6.00172L3.30857 16.8029C3.77605 18.3936 4.7606 19.1901 6.23743 19.2009H11.311C11.311 19.5482 11.311 19.852 11.311 20.158C11.311 20.9002 11.6926 21.3299 12.3413 21.3321C14.7785 21.3321 17.2151 21.3321 19.6511 21.3321C20.3036 21.3321 20.6776 20.898 20.6852 20.1645C20.6852 19.8498 20.6852 19.5352 20.6852 19.2009H25.7244C27.2508 19.2009 28.2163 18.411 28.6952 16.7746C29.7561 13.1678 30.817 9.5558 31.8779 5.93879C31.914 5.83309 31.9548 5.72951 32 5.62845Z",
    fill: "url(#paint0_linear_580_784)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63672 4.28074H9.45975C9.43582 3.81888 9.43582 3.35583 9.45975 2.89397C9.63529 1.20555 10.7381 0.0401489 12.2321 0.0227872C14.7317 -0.00759573 17.2312 -0.00759573 19.7308 0.0227872C21.3374 0.0423191 22.5051 1.40738 22.549 3.2347C22.549 3.56457 22.549 3.89661 22.549 4.26121H30.372C30.3243 4.42831 30.29 4.5455 30.2556 4.66269C29.1413 8.4678 28.0277 12.2722 26.9146 16.0758C26.6876 16.8549 26.4224 17.0741 25.703 17.0741H20.6696C20.6696 16.7247 20.6696 16.397 20.6696 16.0693C20.6775 15.9204 20.6578 15.7714 20.6116 15.6317C20.5655 15.4921 20.494 15.3652 20.4018 15.2591C20.3097 15.153 20.1989 15.0702 20.0767 15.0161C19.9545 14.9621 19.8236 14.9379 19.6926 14.9451C17.2236 14.9451 14.7552 14.9451 12.2875 14.9451C11.6807 14.9451 11.3048 15.3922 11.2972 16.091C11.2972 16.4079 11.2972 16.7247 11.2972 17.0741H11.0797C9.44384 17.0741 7.80864 17.0741 6.17407 17.0741C5.61501 17.0741 5.30209 16.8376 5.13228 16.256C3.97472 12.3192 2.82035 8.38099 1.66915 4.44133C1.65198 4.39576 1.64817 4.35018 1.63672 4.28074ZM20.6867 4.26121C20.6867 3.95087 20.6867 3.67742 20.6867 3.40614C20.6867 2.55108 20.3319 2.14525 19.5801 2.14525H15.5522C14.4703 2.14525 13.3884 2.14525 12.3085 2.14525C11.82 2.14525 11.4346 2.43389 11.364 2.93738C11.3306 3.37696 11.3267 3.8188 11.3525 4.25904L20.6867 4.26121Z",
    fill: "url(#paint1_linear_580_784)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7939 19.1879H13.2109V17.0958H18.7939V19.1879Z",
    fill: "url(#paint2_linear_580_784)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_784",
    x1: 16,
    y1: 5.62845,
    x2: 16,
    y2: 31.9987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_580_784",
    x1: 16.0044,
    y1: 0,
    x2: 16.0044,
    y2: 17.0741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_580_784",
    x1: 16.0024,
    y1: 17.0958,
    x2: 16.0024,
    y2: 19.1879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkIcon);
export default __webpack_public_path__ + "static/media/workIcon.786bfd9922aaa528c294a1781d847264.svg";
export { ForwardRef as ReactComponent };